import SingleModelInterface from '../../types/singleModelInterface'

export default function filterByEngine(
    engineTypes: string[],
    allModels: SingleModelInterface[]
): SingleModelInterface[] {
    if (engineTypes.length) {
        return allModels.filter((model) => {
            const fuels = model.related_promotions.map((promo) => promo.fuels)
            const fuelsInModel = fuels[0]

            return engineTypes.some((engine) => fuelsInModel.includes(engine))
        })
    }

    return allModels
}
